import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function ContentRow({ index, title, copy, bullets, img, flip = false }) {
  return (
    <div className={`grid items-center gap-10 lg:grid-cols-2 ${index > 0 ? "mt-20 sm:mt-28" : ""}`}>
      <Reveal className={flip ? "lg:order-2" : ""}>
        <div className="relative">
          <div className="border border-line p-3">
            <img src={img} alt={title} loading="lazy" className="h-72 w-full object-cover grayscale sm:h-96" />
          </div>
          <span className="absolute -bottom-4 left-6 border border-line bg-ink px-3 py-2 font-mono text-[11px] tracking-[0.3em] text-silver">
            {String(index + 1).padStart(2, "0")}
          </span>
        </div>
      </Reveal>
      <div className={flip ? "lg:order-1" : ""}>
        <Reveal>
          <h2 className="font-display text-2xl font-black uppercase leading-tight tracking-tight sm:text-3xl">{title}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 text-sm leading-relaxed text-mist sm:text-base">{copy}</p>
        </Reveal>
        {bullets && (
          <Reveal delay={0.18}>
            <ul className="mt-6 space-y-3">
              {bullets.map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm text-fog">
                  <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rotate-45 bg-steel" />
                  {b}
                </li>
              ))}
            </ul>
          </Reveal>
        )}
        <Reveal delay={0.24}>
          <Link to="/contact" data-testid={`content-row-${index}-consult-link`} className="link-arrow mt-8">
            Request a Project Consultation <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
